// variant of @vividseats/vivid-ui-kit/dist/components/menu/menu-body/component.tsx

import React, { useContext } from 'react'

import { menuContext } from '@vividseats/vivid-ui-kit'
import classNames from 'classnames'

import styles from './styles.module.scss'

type Props = {
    className?: string
    classes?: {
        root?: string
        mobile?: string
        desktop?: string
    }
    orientation?: 'right' | 'left'
}

const MenuBody: React.FC<Props> = ({ children, className, classes, orientation }) => {
    const { isOpen, bodyRef } = useContext(menuContext)
    return (
        <div
            data-hidden={!isOpen}
            ref={bodyRef}
            className={classNames(className, classes?.root, orientation ? styles[orientation] : undefined)}
            style={{ position: 'relative' }}
        >
            <div
                className={classNames(classes?.desktop, styles.menuBody, styles.desktop)}
                style={{ display: isOpen ? '' : 'none' }}
                data-testid="menu-body-desktop"
            >
                {children}
            </div>
        </div>
    )
}

export default MenuBody
